/*
 * @Author: your name
 * @Date: 2021-07-07 13:43:45
 * @LastEditTime: 2022-03-31 15:27:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/service/PayService.js
 */
import request from '@/utils/request'
import {API} from './apiConfig'
import {saveOrderId ,saveLoadPageStatus} from '../utils/util'
import { isMiniprogram } from "../utils/environment";

let onGetAuthLink = function (orderObj) {
	getAuthLink().then((res) => {
			if (orderObj) {
				saveOrderId(orderObj)
			}
			setTimeout(()=>{
				window.location.href = res.data;
			},100)
	}).catch((err) => console.log(err));
}


export async function onGetAuthStatus(orderObj) {
	// 检测另一个公众号是否授权
	let judgeIsMiniprogram = await isMiniprogram();
	if (judgeIsMiniprogram) {
		saveLoadPageStatus()
		return Promise.resolve(true);
	}
	return getAuthStatus().then((res) => {
		if (!res.data) {
			onGetAuthLink(orderObj);
			return
		}
		saveLoadPageStatus()
		return Promise.resolve(res.data)
	}).catch((err) => {return Promise.reject(false);});
}

export function getAuthStatus() {               // 判断是否授权
	return request({
		method: 'get',
		url: API.getAuthStatus
	})
}

export function getAuthLink() {                  // 获取授权链接
	return request({
		method: 'get',
		url: API.getAuthLink
	})
}

export function getCallBack(code) {                 // 授权回调
	return request({
		method: 'get',
		url: API.getCallBack,
		params: {code: code}
	})
}

export function getPrePay(orderId, price) {                   // 微信预下单
	return request({
		method: 'get',
		url: API.getPrePay,
		params: {orderId: orderId, amount: price}
	})
}

export function getExpireOrder(orderId) {                  // 取消订单
	return request({
		method: 'get',
		url: API.getExpireOrder,
		params: {orderId: orderId}
	})
}

// ----------------------------- 趣直播 充值支付 ---------------------------------
export function postWechatPrepay(data) {
	return axios.post(API.postWechatPrepay, data)
}

export function getOrderList(params) {
	return request({
		method: 'get',
		url: API.getOrderList,
		params
	})
}
